export var AgentRunSourceKind;
(function (AgentRunSourceKind) {
    AgentRunSourceKind["UpdateTodo"] = "update_todo";
    AgentRunSourceKind["Manual"] = "manual";
})(AgentRunSourceKind || (AgentRunSourceKind = {}));
//# sourceMappingURL=source.js.map